import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import TextAreaField from "../../common/htmlComponents/TextAreaField";
import {
  AutoComplete,
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Space,
  Spin,
  Upload,
  Select,
  Checkbox,
  Tooltip,
  Collapse,
  Modal,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  DeleteOutlined,
  FileImageOutlined,
  IdcardOutlined,
  SaveOutlined,
} from "@ant-design/icons";
import PhoneInput from "react-phone-input-2";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import VendorLogoUpload from "../vendor/VendorLogoUpload";
import { t } from "i18next";
import { authUserData } from "../../utils/Helper";
import verifybtn from "../../image/verifybtn.png";
import { ReactComponent as Vector } from "../../image/Vector.svg";
import { ReactComponent as AddressLine } from "../../image/AddressLine.svg";
import { ReactComponent as Email } from "../../image/Email.svg";
import { ReactComponent as Name } from "../../image/Name.svg";
import { ReactComponent as City } from "../../image/City.svg";
import { ReactComponent as ZipCode } from "../../image/ZipCode.svg";
import { ReactComponent as Website } from "../../image/Website.svg";
import { ReactComponent as FileAlt } from "../../image/FileAlt.svg";
import { ReactComponent as About } from "../../image/About.svg";
import { ReactComponent as User } from "../../image/User.svg";
import { getRequest, postRequest } from "../../axios";
import AssignCityVendorStep from "../../authentication/steps/AssignCityVendorStep";
import StepInquiryValueVendor from "../../authentication/steps/StepInquiryValueVendor";
import { Content } from "antd/lib/layout/layout";
import PropTypes from "prop-types";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import VerifyOtpModal from "../../authentication/VerifyOtpModel";
import PhoneOtpVerify from "../../authentication/PhoneOtpVerify";

const SelectVendorAddModal = ({ handleCancel, setReload }) => {
  const { Option } = Select;
  const { t } = useTranslation();
  const { id } = useParams();
  const VendorId = id ? id : null;
  const formRef = useRef();
  const { Panel } = Collapse;
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const userId = authUserData()?.user_id ? authUserData()?.user_id : null;

  const navigate = useNavigate();
  // const initialState = {
  //   vendor_registered_name: null,
  //   person_name: null,
  //   designation: null,
  //   website: null,
  //   no_of_employees: null,
  //   company_pan: null,
  //   gst_no: null,
  //   email: null,
  //   phone: null,
  //   lut_number: null,
  //   msme: false,
  //   msme_number: null,
  //   vendor_trade_name: null,
  //   registered_business_address_building: null,
  //   registered_business_address_area: null,
  //   registered_business_address_landmark: null,
  //   registered_business_address_state: null,
  //   registered_business_address_city: null,
  //   registered_business_address_pincode: null,
  //   trading_address_building: null,
  //   trading_address_area: null,
  //   trading_address_landmark: null,
  //   trading_address_state: null,
  //   trading_address_city: null,
  //   trading_address_pincode: null,
  //   same_as_registered_business_address: false,

  //   vendor_inquiry_value: [
  //     {
  //       company: CompanyId,
  //       category_tree: 1,
  //       company_material_type: null,
  //       minimum_inquiry_value: null,
  //       maximum_inquiry_value: null,
  //     },
  //   ],
  //   assign_city_to_vendor: [
  //     {
  //       company: CompanyId,
  //       category_tree: 1,
  //       material_type: null,
  //       city: [],
  //     },
  //   ],
  //   vendor_company_code: {
  //     company: CompanyId,
  //     vendor_code_by_company: null,
  //   },
  // };

  const initialState = {
    vendor_registered_name: null,
    person_name: null,
    designation: null,
    // address_line_1: null,
    // city: null,
    // state: null,
    // pincode: null,
    website: null,
    no_of_employees: null,
    company_pan: null,
    gst_no: null,
    email: null,
    phone: null,
    lut_number: null,
    msme: false,
    msme_number: null,
    vendor_trade_name: null,
    // registered_business_address: null,
    // trading_address: null,
    phone_verified: false,
    email_verified: false,
    gst_no_verified: false,
    udyam_aadhaar_no_verified: false,
    registered_business_address_building: null,
    registered_business_address_area: null,
    registered_business_address_landmark: null,
    registered_business_address_state: null,
    registered_business_address_city: null,
    registered_business_address_pincode: null,
    trading_address_building: null,
    trading_address_area: null,
    trading_address_landmark: null,
    trading_address_state: null,
    trading_address_city: null,
    trading_address_pincode: null,
    same_as_registered_business_address: false,

    vendor_inquiry_value: [
      {
        company: CompanyId,
        category_tree: 1,
        company_material_type: null,
        minimum_inquiry_value: null,
        maximum_inquiry_value: null,
      },
    ],
    assign_city_to_vendor: [
      {
        company: CompanyId,
        category_tree: 1,
        material_type: null,
        // state: null,
        city: [],
        // gst_number: null,
      },
    ],

    // user: {
    //   company: CompanyId,
    //   vendor_company_code: null,
    // },
    vendor_company_code: {
      company: CompanyId,
      vendor_code_by_company: null,
    },
  };

  const [state, setState] = useState(initialState);
  const [searchValueShippingTrading, setSearchValueShippingTrading] =
    useState("");
  const [verificationResultContact, setVerificationResultContact] =
    useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [verifyGstButtonView, setVerifyGstButtonView] = useState(true);
  const [verificationResultEmail, setVerificationResultEmail] = useState(null);
  const [pincodeListBillingRegistered, setPincodeListBillingRegistered] =
    useState([]);
  const [pincodeListShippingtrading, setPincodeListShippingTrading] = useState(
    []
  );
  const [verificationResultAdhaar, setVerificationResultAadhaar] =
    useState(null);
  const [btnLoadingAdhaar, setBtnLoadingAdhaar] = useState(false);
  const [verifyEmailButtonView, setVerifyEmailButtonView] = useState(true);
  const [gstVendorId, setgstVendorId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const [OTP, setOTP] = useState(null);
  const [btnLoadingPhone, setBtnLoadingPhone] = useState(false);
  const [btnLoadingEmail, setBtnLoadingEmail] = useState(false);
  const [uploadFileProfilePic, setUploadFileProfilePic] = useState("");
  const [verifyGstDisable, setVerifyDisable] = useState(true);
  const [btnLoadingVerifyGst, setBtnLoadingVerifyGst] = useState(false);
  const [isGstNoReadOnly, setIsGstNoReadOnly] = useState(false);
  const [verificationStatus, setVerificationStatus] = useState(null);
  const [verifyAdhaar, setVerifyAdhaar] = useState(false);
  const [postGeneratedVendorId, setPostGeneratedVendorId] = useState(null);
  const [verifyAdhaarButtonView, setVerifyAdhaarButtonView] = useState(true);
  const [isModalOpenPhone, setIsModalOpenPhone] = useState(false);
  const [minutesPhone, setMinutesPhone] = useState(1);
  const [secondsPhone, setSecondsPhone] = useState(0);
  const [OTPPhone, setOTPPhone] = useState(null);
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [searchValueBillingRegistered, setSearchValueBillingResgistered] =
    useState("");
  const [verifyPhoneButtonView, setVerifyPhoneButtonView] = useState(true);
  const [sameAsRegisteredBusinessAddress, setSameAsRegisteredBusinessAddress] =
    useState(false);
  const [uploadFile, setUploadFile] = useState("");
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value !== "" ? value : null });
  };

  const handleGstInputChange = async (e) => {
    let { name, value } = e.target;
    setVerifyGstButtonView(true);
    setState((prevState) => {
      return { ...prevState, gst_no: value };
    });
    setVerificationStatus(null);
    setVerifyDisable(!gstPattern.test(value));
  };

  const showModal = () => {
    setIsModalOpen(true);
  };
  const showModalPhone = () => {
    setIsModalOpenPhone(true);
  };
  const handleCancelEmail = () => {
    setIsModalOpen(false);
    setOTP(null);
    setSeconds(30);
    setMinutes(1);
    setBtnLoadingEmail(false);
  };
  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  const searchINShippingTrading = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListShippingTrading(apiResponse.data.results.data);
    }
  };
  const updateSubscriptionStatus = async () => {
    const response = await getRequest(`user-detail/${userId}`);
    localStorage.setItem("auth_data", JSON.stringify(response.data.data));
  };
  const handlePhoneInputChange = (phone) => {
    setVerifyPhoneButtonView(true);
    setState((prevState) => ({
      ...prevState,
      phone: phone,
      phone_verified: false,
    }));
    setVerificationResultContact("");
  };
  const searchINBillingRegistered = async (value) => {
    const apiResponse = await getRequest(
      `pincode/?search_pincode_number=${value}`
    );
    if (apiResponse.data.results.success) {
      setPincodeListBillingRegistered(apiResponse.data.results.data);
    }
  };
  const handleSendOtpEmail = async () => {
    try {
      const payload = {
        email: state?.email ? state.email : "",
      };
      const response = await postRequest(`verified-otp/email-verify/`, payload);
      if (response.data.success) {
        const errorMessage = response?.data?.message || ""; //
        const emailVerificationRegex = /This [^ ]+ already Verify/;
        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyEmailButtonView(false);

          setState((prevState) => ({
            ...prevState,
            email_verified: true,
          }));
          setVerificationResultEmail("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            email_verified: false,
          }));
          showModal();
          setVerifyEmailButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        handleCancel();
        setVerificationResultEmail("");
      }
    } catch (error) {
      handleCancelEmail();
      setVerifyEmailButtonView(true);
      setVerificationResultEmail("");
    }
  };
  const phoneValidLength = state.phone;
  const handleSendOtpPhone = async () => {
    try {
      const payload = {
        phone_number: state?.phone ? state.phone : "",
      };
      const response = await postRequest(
        `verified-otp/phone-number-verify/`,
        payload
      );
      if (response.data.success) {
        const errorMessage = response?.data?.message || "";
        const emailVerificationRegex = /This [^ ]+ already Verify/;
        if (emailVerificationRegex.test(errorMessage)) {
          setVerifyPhoneButtonView(false);

          setState((prevState) => ({
            ...prevState,
            phone_verified: true,
          }));
          setVerificationResultContact("success");
        } else {
          setState((prevState) => ({
            ...prevState,
            phone_verified: false,
          }));
          showModalPhone();
          setVerifyPhoneButtonView(true);
        }
        SuccessNotificationMsg(response.data.message);
      } else {
        setVerificationResultContact("");
        handleCancelPhone();
        setVerifyPhoneButtonView(true);
      }
    } catch (error) {
      setVerifyPhoneButtonView(true);
      handleCancelPhone();
      setVerificationResultContact("");
    }
  };
  const gstPattern =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const handleCancelPhone = () => {
    setIsModalOpenPhone(false);
    setOTPPhone(null);
    setSecondsPhone(30);
    setMinutesPhone(1);
    setBtnLoadingPhone(false);
  };

  const handleGstNumberVerify = async () => {
    setVerifyDisable(true);
    setVerifyGstButtonView(true);
    try {
      setBtnLoadingVerifyGst(true);
      const gst = state?.gst_no;

      // const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
      // if (!gst || !gstRegex.test(gst)) {
      //   ErrorNotificationMsg(t("Invalid GST No."));
      //   setVerificationResultGST('error');
      //   return;
      // }

      // setBtnLoading(true);
      const apiResponse = await getRequest(
        `doc-verification/gst/?gst_no=${gst}`
      );
      console.log("AIIOOO ", apiResponse);
      if (apiResponse.data.success === true) {
        setState((prevState) => ({
          ...prevState,
          gst_no_verified: true,
        }));
        SuccessNotificationMsg("GST verified successfully");
        setVerificationStatus("success");
        setBtnLoadingVerifyGst(false);
        setVerifyGstButtonView(false);

        if (apiResponse.data.success === true) {
          const {
            company,
            legal_name,
            building_name,
            door_name,
            street,
            city,
            pincode,
            state,
            company_payment_terms,
            keypersons,
            bankdetails,
            assgin_city,
            inquiry_value,
            vendor_company_code_data,
            ...filteredResponse
          } = apiResponse.data.data;

          formRef.current.setFieldsValue({
            vendor_registered_name: legal_name,
            registered_business_address_building: door_name,
            registered_business_address_area: street,
            registered_business_address_pincode: pincode,
          });

          setState((prevState) => ({
            ...prevState,
            vendor_registered_name: legal_name,
            registered_business_address_building: door_name,
            registered_business_address_area: street,
          }));

          handlePincodeBillingChange(pincode);
          searchINBillingRegistered(pincode);
        }
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying GST number"));
      // setVerificationStatus("failure");
      setVerifyDisable(false);
      setBtnLoadingVerifyGst(false);
      setVerifyGstButtonView(true);
    }
  };

  const handlePincodeBillingChange = async (
    registered_business_address_pincode
  ) => {
    if (
      registered_business_address_pincode.length > 4 &&
      registered_business_address_pincode !== null &&
      registered_business_address_pincode !== "" &&
      registered_business_address_pincode !== undefined
    ) {
      try {
        const response = await getRequest(
          `pincode/?search_pincode_number=${registered_business_address_pincode}`
        );
        if (response.data.results.data.length > 0) {
          const { state_name, city_name, id, pincode_number } =
            response.data.results.data[0];
          setState((prevState) => ({
            ...prevState,
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
            registered_business_address_pincode: id,
            registered_business_address_pincode_number: pincode_number,
          }));
          formRef.current.setFieldsValue({
            registered_business_address_state: state_name,
            registered_business_address_city: city_name,
          });
        }
      } catch (error) {
        console.error("Error fetching state and city:", error);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        registered_business_address_state: "",
        registered_business_address_city: "",
        registered_business_address_pincode: "",
        registered_business_address_pincode_number: "",
      }));
      formRef.current.setFieldsValue({
        registered_business_address_state: "",
        registered_business_address_city: "",
      });
    }
  };
  const handleInputChangeVendorCode = (e) => {
    let { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      vendor_company_code: {
        ...prevState.vendor_company_code,
        vendor_code_by_company: value !== "" ? value : null,
      },
    }));
  };

  const handleInputAdhaarChange = (e) => {
    let { name, value } = e.target;
    setVerificationResultAadhaar("");
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    setState({ ...state, udyam_aadhaar_no: value !== "" ? value : null });
  };
  const handleAdhaarNumberVerify = async () => {
    setVerifyAdhaar(true);
    setVerifyAdhaarButtonView(true);
    try {
      const adhaarNumber = state?.udyam_aadhaar_no;
      if (adhaarNumber) {
        setBtnLoadingAdhaar(true);
        const response = await getRequest(
          `doc-verification/udhyam/?udhyam_no=${adhaarNumber}`
        );
        console.log(response, "responseddd");
        if (response.data.success === true) {
          setState((prevState) => ({
            ...prevState,
            udyam_aadhaar_no_verified: true,
          }));
          SuccessNotificationMsg("Udyam Number verified successfully");
          setVerificationResultAadhaar("success");
          setBtnLoadingAdhaar(false);
          setVerifyAdhaarButtonView(false);
        } else {
          // Handle case when GST number is not valid

          setBtnLoadingAdhaar(false);
          // setVerificationResultAadhaar('failure');
          setVerifyAdhaarButtonView(true);
        }
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error in verifying number"));
      setBtnLoadingAdhaar(false);
      // setVerificationResultAadhaar('failure');
      setVerifyAdhaarButtonView(true);
    }
  };
  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    setVerifyEmailButtonView(true);
    setVerificationResultEmail("");
    setState((prevState) => ({
      ...prevState,
      email: value !== "" ? value : null,
      email_verified: false,
    }));
  };
  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 12) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error(t("please_enter_valid_phone")));
    }
    return Promise.resolve();
  };
  const handleContactNumberVerify = async () => {
    const contactNumber = state?.phone;
    const phoneNumberPattern = /^\d{12}$/;
    if (contactNumber && phoneNumberPattern.test(contactNumber)) {
      await handleSendOtpPhone();
    } else {
      ErrorNotificationMsg("Enter valid mobile number");
    }
  };
  const handleEmailVerify = async () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailPattern.test(state.email);
    if (isEmailValid) {
      await handleSendOtpEmail();
    } else {
      setVerifyEmailButtonView(true);
      ErrorNotificationMsg("Enter valid email");
    }
  };
  const onSearchBillingResgistered = async (value) => {
    setSearchValueBillingResgistered(value);
    value.length >= 4
      ? searchINBillingRegistered(!value ? null : value)
      : setPincodeListBillingRegistered([]);
  };
  const onSearchShippingTrading = async (value) => {
    setSearchValueShippingTrading(value);
    value.length >= 4
      ? searchINShippingTrading(!value ? null : value)
      : setPincodeListShippingTrading([]);
  };
  const handleChange = (name, value) => {
    setState({ ...state, [name]: value });
  };
  const handleSameAsRegisteredBusinessAddressChange = (e) => {
    const checked = e.target.checked;
    setSameAsRegisteredBusinessAddress(checked);

    if (checked) {
      setState((prevState) => {
        return {
          ...prevState,
          same_as_registered_business_address: true,
          trading_address_building:
            prevState.registered_business_address_building,
          trading_address_area: prevState.registered_business_address_area,
          trading_address_landmark:
            prevState.registered_business_address_landmark,
          trading_address_state: prevState.registered_business_address_state,
          trading_address_city: prevState.registered_business_address_city,
          trading_address_pincode:
            prevState.registered_business_address_pincode,
          trading_address_pincode_number:
            prevState.registered_business_address_pincode_number,
        };
      });
      formRef.current.setFieldsValue({
        trading_address_building: state.registered_business_address_building,
        trading_address_area: state.registered_business_address_area,
        trading_address_landmark: state.registered_business_address_landmark,
        trading_address_state: state.registered_business_address_state,
        trading_address_city: state.registered_business_address_city,
        trading_address_pincode:
          state.registered_business_address_pincode_number,
      });

      if (
        state?.registered_business_address_state !== null &&
        state?.registered_business_address_state !== undefined &&
        state?.registered_business_address_state !== ""
      ) {
        ////getCityByStateTrading(state.registered_business_address_state);
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        same_as_registered_business_address: false,
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      }));

      formRef.current.setFieldsValue({
        trading_address_building: "",
        trading_address_area: "",
        trading_address_landmark: "",
        trading_address_state: "",
        trading_address_city: "",
        trading_address_pincode: "",
      });
    }
  };
  const handlePincodeShippingTradingChange = async (
    trading_address_pincode
  ) => {
    try {
      const response = await getRequest(
        `pincode/?search_pincode_number=${trading_address_pincode}`
      );
      if (response.data.results.data.length > 0) {
        const { state_name, city_name, id } = response.data.results.data[0];
        setState((prevState) => ({
          ...prevState,
          trading_address_state: state_name,
          trading_address_city: city_name,
          trading_address_pincode: id,
        }));
        formRef.current.setFieldsValue({
          trading_address_state: state_name,
          trading_address_city: city_name,
        });
      }
    } catch (error) {
      // setApiLoading(false);
    }
  };
  const handleSubmit = async () => {
    const payload = {
      vendor_registered_name: state.vendor_registered_name,
      person_name: state.person_name,
      designation: state.designation,
      gst_no: state.gst_no,
      udyam_aadhaar_no: state.udyam_aadhaar_no,
      email: state.email,
      phone: state.phone,
      vendor_trade_name: state.vendor_trade_name,

      email_verified: state.email_verified,
      phone_verified: state.phone_verified,
      gst_no_verified: state.gst_no_verified,
      udyam_aadhaar_no_verified: state.udyam_aadhaar_no_verified,

      registered_business_address_building:
        state.registered_business_address_building,
      registered_business_address_area: state.registered_business_address_area,
      registered_business_address_landmark:
        state.registered_business_address_landmark,
      registered_business_address_state:
        state.registered_business_address_state,
      registered_business_address_city: state.registered_business_address_city,
      registered_business_address_pincode:
        state.registered_business_address_pincode,
      trading_address_building: state.trading_address_building,
      trading_address_area: state.trading_address_area,
      trading_address_landmark: state.trading_address_landmark,
      trading_address_state: state.trading_address_state,
      trading_address_city: state.trading_address_city,
      trading_address_pincode: state.trading_address_pincode,

      vendor_inquiry_value:
        state.vendor_inquiry_value &&
        state.vendor_inquiry_value.every(
          (inquiry) =>
            inquiry.category_tree === null &&
            inquiry.minimum_inquiry_value === null &&
            inquiry.maximum_inquiry_value === null
        )
          ? []
          : state.vendor_inquiry_value,

      assign_city_to_vendor:
        state.assign_city_to_vendor &&
        state.assign_city_to_vendor.every(
          (city) =>
            city.category_tree === null &&
            city.city === null &&
            city.state === null
        )
          ? []
          : state.assign_city_to_vendor,
      vendor_company_code: {
        id: state.vendor_company_code.id,
        company: CompanyId,
        vendor_code_by_company:
          state.vendor_company_code.vendor_code_by_company,
      },
    };

    try {
      setBtnLoading(true);
      let apiResponse;
      let customerHeaders = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      const formData = new FormData();

      formData.append("vendor_logo", uploadFileProfilePic);
      formData.append("msme_document", uploadFile);
      formData.append("form_data", JSON.stringify(payload));
      if (VendorId === null && gstVendorId === null) {
        apiResponse = await postRequest("vendor/", formData, customerHeaders);
      }

      if (apiResponse.data.success === true) {
        setIsGstNoReadOnly(true);
        setPostGeneratedVendorId(apiResponse.data.data.id);

        updateSubscriptionStatus();
        SuccessNotificationMsg(
          VendorId === null
            ? t("vendor_added_successfully")
            : t("vendor_updated_successfully")
        );
      }
      setBtnLoading(false);
      handleCancel();
      setReload((reload) => !reload);
    } catch (error) {
      setBtnLoading(false);
      setIsGstNoReadOnly(false);
    }
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleOkPhone = () => {
    setIsModalOpenPhone(false);
  };
  return (
    <>
      <Form onFinish={handleSubmit} autoComplete="off" ref={formRef}>
        <Content className="stepscontentwrap" style={{ padding: "0" }}>
          <div className="stepsContent">
            <div className="formwrapper" style={{ paddingRight: "5px" }}>
              <div className="colwrap" style={{ marginLeft: "10px" }}>
                <div className="colsubtitle">Business Info</div>
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <div className="verifywrap">
                      <InputField
                        name="gst_no"
                        label={t("place_gst_no5")}
                        placeholder={t("place_gst_no")}
                        rules={t("val_gst_no")}
                        pattern={
                          "^[0-9]{2}[A-Z]{5}[0-9]{4}" +
                          "[A-Z]{1}[1-9A-Z]{1}" +
                          "Z[0-9A-Z]{1}$"
                        }
                        prefix={<IdcardOutlined />}
                        handleInputChange={handleGstInputChange}
                      />
                      {verifyGstButtonView === true ? (
                        <ButtonField
                          type="primary"
                          label={t("Verify")}
                          className="SaveGradiantBtn verify"
                          loading={btnLoadingVerifyGst}
                          onClick={handleGstNumberVerify}
                          disabled={state?.gst_no ? false : true}
                        />
                      ) : (
                        ""
                      )}

                      {verificationStatus === "success" && (
                        <img
                          src={verifybtn}
                          style={{ height: "36px", marginTop: "29px" }}
                        ></img>
                        // <verifyGST className="large-icon" style={{ color: 'green' }} />
                      )}
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <div className="verifywrap">
                      <InputField
                        name="udyam_aadhaar_no"
                        label={t("Udyam Number")}
                        placeholder={t("Enter Udyam Number")}
                        // pattern={"^[A-Z]{5}[0-9]{4}[A-Z]{1}$"}
                        // pattern={
                        //   "^[A-Z]{5}-[A-Z]{2}-[0-9]{2}-[0-9]{7}$"
                        // }
                        // nonRequiredRules={t("val_company_pan")}
                        // rules={t("Please enter valid udyam aadhar")}
                        prefix={<IdcardOutlined />}
                        handleInputChange={handleInputAdhaarChange}
                      />
                      {verifyAdhaarButtonView === true ? (
                        <ButtonField
                          type="primary"
                          className="SaveGradiantBtn verify"
                          // htmlType="Submit"
                          onClick={handleAdhaarNumberVerify}
                          label={t("Verify")}
                          loading={btnLoadingAdhaar}
                          disabled={state?.udyam_aadhaar_no ? false : true}
                        />
                      ) : (
                        ""
                      )}

                      {verificationResultAdhaar === "success" && (
                        <img
                          src={verifybtn}
                          style={{ height: "36px", marginTop: "29px" }}
                        ></img>
                        // <verifyGST className="large-icon" style={{ color: 'green' }} />
                      )}
                    </div>
                  </Col>

                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <div className="verifywrap">
                      <InputField
                        name="vendor_registered_name"
                        label={t("label_vendor_company_name")}
                        placeholder={t("pl_vendor_company_name")}
                        rules={t("val_vendor_company_name")}
                        prefix={<Vector />}
                        handleInputChange={handleInputChange}
                        max={30}
                      />
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <div className="verifywrap">
                      <InputField
                        placeholder="Enter vendor trade name"
                        name="vendor_trade_name"
                        label={t("Vendor Trade Name")}
                        rules={t("Please enter vendor trade name")}
                        prefix={<AddressLine />}
                        handleInputChange={handleInputChange}
                        max={50}
                      />
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <div className="verifywrap">
                      <InputField
                        name="vendor_code_by_company"
                        label={t("Vender Code as per Company ERP System")}
                        placeholder={t("pl_enter_vendor_code")}
                        handleInputChange={handleInputChangeVendorCode}
                        prefix={<FileAlt />}
                        rules={t("Please enter vendor code")}
                      />
                    </div>
                  </Col>
                </Row>
                <div className="vendorsubtitle">Contact Information</div>
                <Row gutter={16}>
                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <InputField
                      name="person_name"
                      label={t("label_person_name")}
                      placeholder={t("pl_person_name")}
                      rules={t("val_person_name")}
                      prefix={<Name />}
                      handleInputChange={handleInputChange}
                      max={30}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <InputField
                      name="designation"
                      label={t("label_designation")}
                      placeholder={t("pl_designation")}
                      rules={t("val_designation")}
                      prefix={<AddressLine />}
                      handleInputChange={handleInputChange}
                      max={30}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <div className="verifywrap">
                      <EmailField
                        name="email"
                        label={t("label_email")}
                        placeholder={t("pl_email_2")}
                        rules={t("val_email")}
                        prefix={<Email />}
                        handleInputChange={handleInputChangeEmail}
                      />
                      {verifyEmailButtonView === true ? (
                        <ButtonField
                          type="primary"
                          className="SaveGradiantBtn verify"
                          onClick={handleEmailVerify}
                          label={t("Verify")}
                          loading={btnLoadingEmail}
                        />
                      ) : (
                        ""
                      )}

                      {verificationResultEmail === "success" && (
                        <img
                          src={verifybtn}
                          style={{ height: "36px", marginTop: "29px" }}
                        ></img>
                      )}
                    </div>
                  </Col>
                  <Col xs={24} sm={24} md={12} xl={12} xxl={12}>
                    <div className="verifywrap">
                      <Form.Item
                        name="phone"
                        label={t("label_mobileNumber")}
                        placeholder={t("pl_mobileNumber")}
                        rules={[
                          {
                            required: true,
                            validator: validatePhoneNumber,
                            message: <Trans> {t("val_mobileNumber")}</Trans>,
                          },
                        ]}
                      >
                        <PhoneInput
                          className="PhoneSection"
                          country={"in"}
                          value={state.phone}
                          onChange={handlePhoneInputChange}
                        />
                      </Form.Item>
                      {verifyPhoneButtonView === true ? (
                        <ButtonField
                          type="primary"
                          className="SaveGradiantBtn verify"
                          onClick={handleContactNumberVerify}
                          label={t("Verify")}
                          loading={btnLoadingPhone}
                        />
                      ) : (
                        ""
                      )}

                      {verificationResultContact === "success" && (
                        <img
                          src={verifybtn}
                          style={{ height: "36px", marginTop: "29px" }}
                        ></img>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>

              <Row gutter={32}>
                <Col xs={24} xxl={12} className="bdr">
                  <div className="colwrap">
                    <div className="colsubtitle">
                      Registered Business Address
                    </div>
                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="registered_business_address_building"
                          label={t("Shop No., Building, Apartment")}
                          rules={[
                            {
                              required: true,
                              message: t(
                                "Please enter shop no., building, company, apartment"
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t(
                              "Enter shop no., building, apartment"
                            )}
                            maxLength={50}
                            value={state.registered_business_address_building}
                            onChange={(e) =>
                              handleChange(
                                "registered_business_address_building",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="registered_business_address_area"
                          label={t("Area, Street")}
                          rules={[
                            {
                              required: true,
                              message: t("Please enter Area, Street"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Enter area, street")}
                            maxLength={50}
                            value={state.registered_business_address_area}
                            onChange={(e) =>
                              handleChange(
                                "registered_business_address_area",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="registered_business_address_landmark"
                          label={t("Landmark")}
                          rules={[
                            {
                              required: true,
                              message: t("Please enter landmark"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Enter landmark")}
                            maxLength={50}
                            value={state.registered_business_address_landmark}
                            onChange={(e) =>
                              handleChange(
                                "registered_business_address_landmark",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item
                          name="registered_business_address_pincode"
                          label={t("pl_pincode")}
                          prefix={<ZipCode />}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("val_postal_zip_code")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <AutoComplete
                            className="autoComplete"
                            onSearch={onSearchBillingResgistered}
                            value={state.registered_business_address_pincode}
                            optionFilterProp="children"
                            allowClear
                            placeholder={t("pl_pincodeselect")}
                            onChange={handlePincodeBillingChange}
                          >
                            {pincodeListBillingRegistered.map((option) => (
                              <Option
                                key={option.id}
                                value={option.pincode_number}
                              >
                                {option.pincode_number}
                              </Option>
                            ))}
                          </AutoComplete>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="registered_business_address_city"
                          label={t("pl_city")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_city")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("place_city")}
                            value={state.registered_business_address_city}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="registered_business_address_state"
                          label={t("pl_state_province")}
                          value={state.registered_business_address_state}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_state_province")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            value={state.registered_business_address_state}
                            placeholder={t("place_state")}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col xs={24} xxl={12}>
                  <div className="colwrap">
                    <div className="colsubtitle">
                      Trading Address
                      <Tooltip
                        title="Same as registered business address"
                        name="same_as_registered_business_address"
                      >
                        <Checkbox
                          style={{ marginLeft: "10px" }}
                          checked={sameAsRegisteredBusinessAddress}
                          onChange={(e) =>
                            handleSameAsRegisteredBusinessAddressChange(e)
                          }
                        >
                          Same as my business address
                        </Checkbox>
                      </Tooltip>
                    </div>
                    <Row gutter={16}>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="trading_address_building"
                          label={t("Shop No., Building, Company, Apartment")}
                          rules={[
                            {
                              required: true,
                              message: t(
                                "Please enter shop no., building, company, apartment"
                              ),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t(
                              "Enter shop no., building, company, apartment"
                            )}
                            maxLength={50}
                            value={state.trading_address_building}
                            onChange={(e) =>
                              handleChange(
                                "trading_address_building",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="trading_address_area"
                          label={t("Area, Street")}
                          rules={[
                            {
                              required: true,
                              message: t("Please enter Area, Street"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Enter area, street")}
                            maxLength={50}
                            value={state.trading_address_area}
                            onChange={(e) =>
                              handleChange(
                                "trading_address_area",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="trading_address_landmark"
                          label={t("Landmark")}
                          rules={[
                            {
                              required: true,
                              message: t("Please enter landmark"),
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("Enter landmark")}
                            maxLength={50}
                            value={state.trading_address_landmark}
                            onChange={(e) =>
                              handleChange(
                                "trading_address_landmark",
                                e.target.value
                              )
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="trading_address_pincode"
                          label={t("pl_pincode")}
                          prefix={<ZipCode />}
                          rules={[
                            {
                              required: true,
                              message: (
                                <Trans>{t("val_postal_zip_code")}</Trans>
                              ),
                            },
                          ]}
                        >
                          <AutoComplete
                            className="autoComplete"
                            onSearch={onSearchShippingTrading}
                            value={state.trading_address_pincode}
                            optionFilterProp="children"
                            allowClear
                            placeholder={t("pl_pincodeselect")}
                            onChange={handlePincodeShippingTradingChange}
                          >
                            {pincodeListShippingtrading.map((option) => (
                              <Option
                                key={option.id}
                                value={option.pincode_number}
                              >
                                {option.pincode_number}
                              </Option>
                            ))}
                          </AutoComplete>
                        </Form.Item>
                      </Col>
                      <Col xs={24} md={12}>
                        <Form.Item
                          name="trading_address_city"
                          label={t("pl_city")}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_city")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("place_city")}
                            value={state.trading_address_city}
                            disabled
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} md={12}>
                        <Form.Item
                          name="trading_address_state"
                          label={t("pl_state_province")}
                          value={state.trading_address_state}
                          rules={[
                            {
                              required: true,
                              message: <Trans>{t("val_state_province")}</Trans>,
                            },
                          ]}
                        >
                          <Input
                            placeholder={t("place_state")}
                            value={state.trading_address_state}
                            disabled
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>

              <StepInquiryValueVendor
                state={state}
                setState={setState}
                CompanyId={CompanyId}
              />

              <>
                <div className="vendorsubtitle">Assign City</div>
                <AssignCityVendorStep
                  state={state}
                  setState={setState}
                  companyId={CompanyId}
                  VendorId={VendorId}
                />
              </>
              <div className="btnwrp2">
                <ButtonField
                  className="CancelGradiantBtn"
                  type="primary"
                  label={t("cancel")}
                  onClick={backToList}
                />
                <Button
                  cursor="pointer"
                  className="SaveGradiantBtn"
                  type="primary"
                  icon={<SaveOutlined />}
                  htmlType="submit"
                  label="Save"
                >
                  Save
                </Button>
              </div>
            </div>
          </div>
        </Content>
      </Form>
      <Modal
        className="ModelPopupSec"
        title={"Verify Email"}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancelEmail}
        closable={handleCancelEmail}
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        {/* <Tabs defaultActiveKey="1" items={items} onChange={onChange} /> */}
        <VerifyOtpModal
          // zoneList={zoneList}
          handleCancel={handleCancelEmail}
          setVerifyEmailButtonView={setVerifyEmailButtonView}
          OTP={OTP}
          setOTP={setOTP}
          state={state}
          setState={setState}
          setMinutes={setMinutes}
          setSeconds={setSeconds}
          seconds={seconds}
          minutes={minutes}
          handleSendOtpEmail={handleSendOtpEmail}
          setVerificationResultEmail={setVerificationResultEmail}
          // reload={reload}
          // setReload={setReload}
          // handleCancel={handleCancel}
          // pincodeId={pincodeId}
          // modalKey={modalKey}
          // setStateM = {setState}
        />
      </Modal>

      <Modal
        className="ModelPopupSec"
        title={"Verify Mobile"}
        open={isModalOpenPhone}
        onOk={handleOkPhone}
        onCancel={handleCancelPhone}
        closable={handleCancelPhone}
        wrapClassName="modal-wrapper"
        keyboard={false}
      >
        {/* <Tabs defaultActiveKey="1" items={items} onChange={onChange} /> */}
        <PhoneOtpVerify
          // zoneList={zoneList}
          handleCancelPhone={handleCancelPhone}
          setVerifyPhoneButtonView={setVerifyPhoneButtonView}
          OTP={OTPPhone}
          setOTP={setOTPPhone}
          state={state}
          setState={setState}
          setMinutes={setMinutesPhone}
          setSeconds={setSecondsPhone}
          seconds={secondsPhone}
          minutes={minutesPhone}
          handleSendOtpPhone={handleSendOtpPhone}
          setVerificationResultContact={setVerificationResultContact}
          // reload={reload}
          // setReload={setReload}
          // handleCancel={handleCancel}
          // pincodeId={pincodeId}
          // modalKey={modalKey}
          // setStateM = {setState}
          // mode={"email"}
        />
      </Modal>
    </>
  );
};
SelectVendorAddModal.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
};
export default SelectVendorAddModal;
